export default __webpack_public_path__ + "static/N0125-f972b8f8074655164a1c17d2a57b3c97.png";